// packages/core/src/quizzes/discoveryRegistry.ts
// ─────────────────────────────────────────────────────────────────────────
// The discovery quiz catalog. Eight quizzes, all live. (The 2008 crash
// quiz was cut: Market Replay already delivers that experience directly,
// so a quiz wrapper added effort without adding value.)
//
// One content map per engine. Adding a quiz = author its content file,
// register it in its engine's map, add its meta here. No surface changes.
// ─────────────────────────────────────────────────────────────────────────

import type {
	DiscoveryQuizId,
	DiscoveryQuizMeta,
	EstimateQuizContent,
	IndexQuizContent,
	TradeoffQuizContent,
} from './DiscoveryTypes';
import { MONEY_INTUITION } from './content/moneyIntuition';
import { FREEDOM_ARCHETYPE } from './content/freedomArchetype';
import { GOLDEN_HANDCUFFS } from './content/goldenHandcuffs';
import { INCOME_OR_LEAKS } from './content/incomeOrLeaks';
import { MISSED_WINDOW } from './content/missedWindow';
import { RETIREMENT_REALITY } from './content/retirementReality';
import { SAME_GAME } from './content/sameGame';
import { SCHOOL_MATCH } from './content/schoolMatch';

/** Hub display order. */
export const DISCOVERY_QUIZZES: readonly DiscoveryQuizMeta[] = [
	MONEY_INTUITION.meta,
	RETIREMENT_REALITY.meta,
	FREEDOM_ARCHETYPE.meta,
	GOLDEN_HANDCUFFS.meta,
	INCOME_OR_LEAKS.meta,
	MISSED_WINDOW.meta,
	SCHOOL_MATCH.meta,
	SAME_GAME.meta,
];

const ESTIMATE_CONTENT: Partial<
	Record<DiscoveryQuizId, EstimateQuizContent>
> = {
	'money-intuition': MONEY_INTUITION,
	'retirement-reality': RETIREMENT_REALITY,
};

const TRADEOFF_CONTENT: Partial<
	Record<DiscoveryQuizId, TradeoffQuizContent>
> = {
	'freedom-archetype': FREEDOM_ARCHETYPE,
	'same-game': SAME_GAME,
	'school-match': SCHOOL_MATCH,
};

const INDEX_CONTENT: Partial<Record<DiscoveryQuizId, IndexQuizContent>> = {
	'golden-handcuffs': GOLDEN_HANDCUFFS,
	'income-or-leaks': INCOME_OR_LEAKS,
	'missed-window': MISSED_WINDOW,
};

export function getDiscoveryMeta(
	id: string,
): DiscoveryQuizMeta | undefined {
	return DISCOVERY_QUIZZES.find((q) => q.id === id);
}

export function getEstimateContent(
	id: string,
): EstimateQuizContent | undefined {
	return ESTIMATE_CONTENT[id as DiscoveryQuizId];
}

export function getTradeoffContent(
	id: string,
): TradeoffQuizContent | undefined {
	return TRADEOFF_CONTENT[id as DiscoveryQuizId];
}

export function getIndexContent(
	id: string,
): IndexQuizContent | undefined {
	return INDEX_CONTENT[id as DiscoveryQuizId];
}
